module.exports = __webpack_public_path__ + "static/media/einstellungen.958cefbd.svg";